import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, Paper, TextField, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import withServices from '../../../../hocs/withServices'
import { Alert } from '@material-ui/lab'

const ContractSign = ({ services, contract, dormitories, fetchContract }) => {
    const [parentIin, setParentIin] = React.useState('');
    const [parentEmail, setParentEmail] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [isUnderage, setIsUnderage] = React.useState(false);
    const [isForeign, setIsForeign] = React.useState(false);  
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        services.personalPage.getPersonalInformation()
            .then((response) => {
                setIsUnderage(new Date().getFullYear() - new Date(response.data?.dateOfBirth).getFullYear() < 18);
                setIsForeign(response.data?.citizenship.id !== 86);
            })
    }, [])

    const handleSignContract = () => {
        setIsLoading(true);
        services.dormContract.sendContract2Podpishi({
            parentIin: parentIin,
            parentEmail: parentEmail,
        })
            .then((res) => {
                fetchContract();
                setOpen(false);
                window.open(res.data, '_blank');
            })
            .finally(() => setIsLoading(false));
    }

    const handleSign = () => {
        if (contract.podpishiDocHash && contract.podpishiDocNum) {
            return window.open(`https://api.podpishi.kz/qr.php?id1=${contract.podpishiDocNum}&id2=${contract.podpishiDocHash}`, '_blank')
        }
        else if (isUnderage && !isForeign) {
            return setOpen(true);
        }
        else {
            return handleSignContract();
        }
    }



    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                marginTop: '30px',
                marginBottom: '30px'
            }}
        >
            {contract?.approved === null && (
                <Alert severity="info">
                    Подождите, пока договор подготовится к подписи.
                    Наши специалисты обрабатывают ваш запрос
                </Alert>
            )}

            {contract?.comment && (
                <Alert severity="warning">
                    {contract.comment}
                </Alert>
            )}

            {dormitories && dormitories.filter(v => v.rooms.some(room => room.id === contract.dormitoryRoomId)).map(
                dormitory => (
                    <Paper variant="outlined" square style={{ padding: '20px', width: '100%' }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                            <Typography variant="h5">Выбранное общежитие</Typography>
                            <Typography variant="h6">{dormitory.name + " / " + dormitory.nameRu + " / " + dormitory.nameEn}</Typography>
                            <Card variant='outlined'>
                                <CardContent>
                                    <Typography variant="body1">Количество комнат: {dormitory.roomCount}</Typography>
                                    <Typography variant="body1">Адрес: {dormitory.address}</Typography>
                                    <Typography variant="body1">Этажей: {dormitory.floorCount}</Typography>
                                    <Typography variant="body1">Лифтов: {dormitory.liftCount}</Typography>
                                    <Typography variant="body1">Парковка: {dormitory.hasParking ? 'Да' : 'Нет'}</Typography>
                                    <Typography variant="body1">Специальные туалеты: {dormitory.hasSpecialToilets ? 'Да' : 'Нет'}</Typography>
                                    <Typography variant="body1">Телефон: {dormitory.phone}</Typography>
                                    <Typography variant="body1">Годовая оплата: {dormitory.payYear}</Typography>
                                    <Typography variant="body1">Дата ремонта: {dormitory.repairDate}</Typography>
                                    <Typography variant="body1">Площадь: {dormitory.square} м²</Typography>
                                </CardContent>
                            </Card>
                            <Typography variant="h5">Выбранная комната</Typography>

                            {dormitory.rooms.filter(room => room.id === contract.dormitoryRoomId).map(room => (
                                <Card variant='outlined'>
                                    <CardContent>
                                        <Typography variant="body1">Комната №{room.number}</Typography>
                                        <Typography variant="body1">Этаж: {room.floor}</Typography>
                                        <Typography variant="body1">Количество мест: {room.beds}</Typography>
                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </Paper>

                )
            )}

            {contract && contract.approved === true && (
                <>
                    <Button variant="contained" component="span" color="primary"
                        onClick={handleSign}
                        disabled={isLoading}
                    >
                        {contract.podpishiDocHash && contract.podpishiDocNum ? "Посмотреть договор" : "Подписать договор"}
                    </Button>
                    <Dialog open={open} onClose={() => { setOpen(false) }} aria-labelledby="form-contract">
                        <DialogContent>
                            <DialogContentText>
                                Вы являетесь не совершеннолетним, поэтому для подписания договора необходимо указать данные законного представителя
                            </DialogContentText>
                            <TextField
                                fullWidth
                                margin="normal"
                                value={parentIin}
                                label="ИИН"
                                onChange={(e) => {
                                    let value = e.target.value;
                                    value = value.replace(/[^0-9]/gi, "");
                                    setParentIin(value);
                                }}
                                error={parentIin?.length < 12 && parentIin?.length > 0}
                                inputProps={{ maxLength: 12 }}
                            />
                            <TextField
                                margin="normal"
                                id="email"
                                label="Email"
                                type="email"
                                fullWidth
                                value={parentEmail}
                                onChange={(e) => setParentEmail(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => { setOpen(false) }}
                                color="primary"
                                disabled={isLoading}
                            >
                                Закрыть
                            </Button>
                            <Button
                                onClick={() => { handleSignContract() }}
                                variant="contained"
                                color="primary"
                                disabled={isLoading}
                            >
                                Подписать
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
        </div>
    )
}

export default withServices()(ContractSign)